function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.55 3.389c2-1.137 4.45.354 4.45 2.707v19.808c0 2.353-2.45 3.844-4.45 2.707l-11.308-6.429H6c-1.657 0-3-1.384-3-3.09v-6.183c0-1.707 1.343-3.091 3-3.091h5.242l11.309-6.429zm-12.05 8.49H6c-.552 0-1 .46-1 1.03v6.182c0 .57.448 1.03 1 1.03h4.5V11.88zm2 8.665l11.017 6.263c.666.379 1.483-.118 1.483-.903V6.096c0-.785-.817-1.281-1.483-.903L12.5 11.456v9.088z",
  fill: "currentColor"
})));